/* Kallistia Help Center — Accordion-based design JS */

(function() {
  'use strict';

  // ============ SMOOTH ACCORDION HELPER ============
  // Measures actual scrollHeight for buttery transitions instead of max-height hacks
  function openAccordion(body) {
    body.style.maxHeight = body.scrollHeight + 'px';
  }
  function closeAccordion(body) {
    // Set explicit current height first so transition has a start value
    body.style.maxHeight = body.scrollHeight + 'px';
    body.offsetHeight; // force reflow
    body.style.maxHeight = '0';
  }
  // After open transition ends, allow content to reflow (e.g. nested accordions changing height)
  function unlockAfterTransition(body) {
    body.addEventListener('transitionend', function handler(e) {
      if (e.propertyName === 'max-height' && body.closest('.open')) {
        body.style.maxHeight = 'none';
      }
      body.removeEventListener('transitionend', handler);
    });
  }
  // Recalculate ancestor accordion heights when a nested accordion changes
  function updateAncestorHeights(el) {
    var parent = el.parentElement;
    while (parent) {
      if ((parent.classList.contains('kl-hc-subcat-body') || parent.classList.contains('kl-hc-faq-a') || parent.classList.contains('kl-hc-pop-a')) && parent.style.maxHeight && parent.style.maxHeight !== 'none' && parent.style.maxHeight !== '0' && parent.style.maxHeight !== '0px') {
        parent.style.maxHeight = parent.scrollHeight + 'px';
      }
      parent = parent.parentElement;
    }
  }

  // ============ SUBCATEGORY ACCORDION ============
  document.querySelectorAll('.kl-hc-subcat-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var subcat = this.closest('.kl-hc-subcat');
      var body = subcat.querySelector('.kl-hc-subcat-body');
      var isOpen = subcat.classList.contains('open');

      this.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');

      if (isOpen) {
        closeAccordion(body);
        subcat.classList.remove('open');
      } else {
        subcat.classList.add('open');
        openAccordion(body);
        unlockAfterTransition(body);
      }
    });
  });

  // ============ FAQ ACCORDION (inside subcategories) ============
  document.querySelectorAll('.kl-hc-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.kl-hc-faq-item');
      var subcat = this.closest('.kl-hc-subcat-body');
      var isOpen = item.classList.contains('open');

      // Close other open items in the same subcategory
      if (subcat) {
        subcat.querySelectorAll('.kl-hc-faq-item.open').forEach(function(openItem) {
          if (openItem !== item) {
            var openBody = openItem.querySelector('.kl-hc-faq-a');
            closeAccordion(openBody);
            openItem.classList.remove('open');
            openItem.querySelector('.kl-hc-faq-q').setAttribute('aria-expanded', 'false');
          }
        });
      }

      if (isOpen) {
        var body = item.querySelector('.kl-hc-faq-a');
        closeAccordion(body);
        item.classList.remove('open');
        this.setAttribute('aria-expanded', 'false');
        history.replaceState(null, '', window.location.pathname + window.location.search);
      } else {
        item.classList.add('open');
        var body = item.querySelector('.kl-hc-faq-a');
        openAccordion(body);
        unlockAfterTransition(body);
        updateAncestorHeights(body);
        this.setAttribute('aria-expanded', 'true');
        history.replaceState(null, '', '#' + item.id);
      }
    });
  });

  // ============ SHARE / COPY LINK (delegated for dynamic hits) ============
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-faq-share]');
    if (!btn) return;
    e.stopPropagation();
    var slug = btn.getAttribute('data-faq-share');
    var url = window.location.origin + window.location.pathname + '#' + (slug.indexOf('faq-') === 0 ? slug : 'faq-' + slug);
    var label = btn.querySelector('.kl-hc-share-label');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function() {
        showCopied(btn, label);
      }).catch(function() {
        fallbackCopy(url);
        showCopied(btn, label);
      });
    } else {
      fallbackCopy(url);
      showCopied(btn, label);
    }
  });

  function fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  function showCopied(btn, label) {
    btn.classList.add('copied');
    if (label) label.textContent = 'Copied!';
    var svg = btn.querySelector('svg');
    if (svg) {
      var origSvg = svg.innerHTML;
      svg.innerHTML = '<polyline points="20 6 9 17 4 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>';
      setTimeout(function() {
        svg.innerHTML = origSvg;
      }, 2000);
    }
    setTimeout(function() {
      btn.classList.remove('copied');
      if (label) label.textContent = 'Copy link';
    }, 2000);
  }

  // ============ POPULAR ACCORDION ============
  document.querySelectorAll('.kl-hc-pop-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.kl-hc-pop-item');
      var isOpen = item.classList.contains('open');

      document.querySelectorAll('.kl-hc-pop-item.open').forEach(function(openItem) {
        if (openItem !== item) {
          var openBody = openItem.querySelector('.kl-hc-pop-a');
          closeAccordion(openBody);
          openItem.classList.remove('open');
        }
      });

      if (isOpen) {
        var body = item.querySelector('.kl-hc-pop-a');
        closeAccordion(body);
        item.classList.remove('open');
      } else {
        item.classList.add('open');
        var body = item.querySelector('.kl-hc-pop-a');
        openAccordion(body);
        unlockAfterTransition(body);
      }
    });
  });

  // ============ SEARCH (self-contained — doesn't touch page FAQs) ============
  var searchInput = document.getElementById('klHcSearchInput');
  var searchWrap = document.getElementById('klHcSearch');
  var clearBtn = document.getElementById('klHcSearchClear');
  var countEl = document.getElementById('klHcSearchCount');
  var searchPanel = document.getElementById('klHcSearchPanel');
  var hitsEl = document.getElementById('klHcSearchHits');
  var noResults = document.getElementById('klHcNoResults');
  var aiSkeleton = document.getElementById('klHcAiSkeleton');
  var aiResultEl = document.getElementById('klHcAiResult');
  var quickLinks = document.getElementById('klHcQuickLinks');
  var faqItems = document.querySelectorAll('[data-faq]');
  var apiUrl = window.klHcApiUrl || '';
  var abortCtrl = null;

  // Build search index from page FAQ content
  var faqIndex = [];
  faqItems.forEach(function(item) {
    var qEl = item.querySelector('.kl-hc-faq-q');
    var aEl = item.querySelector('.kl-hc-faq-a-inner').cloneNode(true);
    var shareBtn = aEl.querySelector('.kl-hc-faq-share');
    if (shareBtn) shareBtn.remove();
    faqIndex.push({
      slug: item.id,
      qText: qEl.textContent.toLowerCase(),
      aText: aEl.textContent.toLowerCase(),
      qHtml: qEl.textContent,
      aHtml: aEl.innerHTML
    });
  });

  var debounceTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, 150);
      searchWrap.classList.toggle('has-value', this.value.length > 0);
    });

    searchInput.addEventListener('focus', function() { searchWrap.classList.add('focused'); });
    searchInput.addEventListener('blur', function() { searchWrap.classList.remove('focused'); });
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      searchInput.value = '';
      searchWrap.classList.remove('has-value');
      doSearch();
      searchInput.focus();
    });
  }

  var clearSearchLink = document.getElementById('klHcClearSearch');
  if (clearSearchLink) {
    clearSearchLink.addEventListener('click', function(e) {
      e.preventDefault();
      searchInput.value = '';
      searchWrap.classList.remove('has-value');
      doSearch();
    });
  }

  function resetPanel() {
    if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }
    if (searchPanel) searchPanel.classList.remove('visible');
    if (hitsEl) hitsEl.innerHTML = '';
    if (aiSkeleton) aiSkeleton.classList.remove('visible');
    if (aiResultEl) { aiResultEl.classList.remove('visible'); aiResultEl.innerHTML = ''; }
    if (noResults) noResults.classList.remove('visible');
    countEl.classList.remove('visible');
    if (quickLinks) quickLinks.style.display = '';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function highlightText(html, word) {
    var regex = new RegExp('(' + escapeRegex(word) + ')', 'gi');
    return html.replace(/>([^<]+)</g, function(m, text) {
      return '>' + text.replace(regex, '<mark class="kl-hc-match">$1</mark>') + '<';
    });
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Render keyword matches as mini-accordions in the search panel
  function renderHits(matches, words) {
    if (!hitsEl) return;
    var html = '';
    for (var i = 0; i < matches.length; i++) {
      var f = matches[i];
      var q = escapeHtml(f.qHtml);
      var a = f.aHtml;
      for (var w = 0; w < words.length; w++) {
        q = highlightText(q, words[w]);
        a = highlightText(a, words[w]);
      }
      html +=
        '<div class="kl-hc-hit" data-hit-slug="' + f.slug + '">' +
          '<button class="kl-hc-hit-q" aria-expanded="false">' + q +
            '<span class="kl-hc-hit-chevron"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="6 9 12 15 18 9"/></svg></span>' +
          '</button>' +
          '<div class="kl-hc-hit-a"><div class="kl-hc-hit-a-inner">' + a +
            '<button class="kl-hc-faq-share" data-faq-share="' + f.slug + '" aria-label="Copy link to this article">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>' +
              '<span class="kl-hc-share-label">Copy link</span>' +
            '</button>' +
          '</div></div>' +
        '</div>';
    }
    hitsEl.innerHTML = html;

    // Wire up accordion toggles
    hitsEl.querySelectorAll('.kl-hc-hit-q').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var hit = this.closest('.kl-hc-hit');
        var hitBody = hit.querySelector('.kl-hc-hit-a');
        var isOpen = hit.classList.contains('open');
        // Close siblings
        hitsEl.querySelectorAll('.kl-hc-hit.open').forEach(function(h) {
          if (h !== hit) {
            closeAccordion(h.querySelector('.kl-hc-hit-a'));
            h.classList.remove('open');
            h.querySelector('.kl-hc-hit-q').setAttribute('aria-expanded', 'false');
          }
        });
        if (isOpen) {
          closeAccordion(hitBody);
          hit.classList.remove('open');
          this.setAttribute('aria-expanded', 'false');
        } else {
          hit.classList.add('open');
          openAccordion(hitBody);
          unlockAfterTransition(hitBody);
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function fetchAiAnswer(query, keywordCount) {
    if (!apiUrl) return;
    if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }

    if (aiSkeleton) aiSkeleton.classList.add('visible');
    if (keywordCount === 0) countEl.textContent = 'Searching\u2026';

    abortCtrl = new AbortController();
    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: query }),
      signal: abortCtrl.signal
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (aiSkeleton) aiSkeleton.classList.remove('visible');
      if (!data || !data.answer) {
        if (keywordCount === 0) {
          countEl.textContent = '0 results found';
          if (noResults) noResults.classList.add('visible');
        }
        return;
      }

      var title = escapeHtml(data.title || query);
      var answer = escapeHtml(data.answer);
      var total = keywordCount + 1;

      aiResultEl.innerHTML =
        '<div class="kl-hc-ai-card open">' +
          '<div class="kl-hc-ai-card-header">' +
            '<span class="kl-hc-ai-badge"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>Best match</span>' +
            '<span class="kl-hc-ai-title">' + title + '</span>' +
            '<svg class="kl-hc-ai-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="6 9 12 15 18 9"/></svg>' +
          '</div>' +
          '<div class="kl-hc-ai-body"><div class="kl-hc-ai-body-inner">' + answer +
            '<div class="kl-hc-ai-source"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></svg>From Help Centre</div>' +
          '</div></div>' +
        '</div>';
      aiResultEl.classList.add('visible');

      countEl.textContent = total + ' result' + (total !== 1 ? 's' : '') + ' found';
      if (noResults) noResults.classList.remove('visible');

      var card = aiResultEl.querySelector('.kl-hc-ai-card');
      if (card) {
        var aiBody = card.querySelector('.kl-hc-ai-body');
        // Card starts open — set initial max-height
        if (aiBody) aiBody.style.maxHeight = 'none';
        card.querySelector('.kl-hc-ai-card-header').addEventListener('click', function() {
          var wasOpen = card.classList.contains('open');
          if (wasOpen) {
            closeAccordion(aiBody);
            card.classList.remove('open');
          } else {
            card.classList.add('open');
            openAccordion(aiBody);
            unlockAfterTransition(aiBody);
          }
        });
      }
    })
    .catch(function(err) {
      if (err.name !== 'AbortError') {
        if (aiSkeleton) aiSkeleton.classList.remove('visible');
        if (keywordCount === 0) {
          countEl.textContent = '0 results found';
          if (noResults) noResults.classList.add('visible');
        }
      }
    });
  }

  function doSearch() {
    var query = searchInput.value.trim().toLowerCase();

    // Clear → hide panel, restore quick links
    if (!query) {
      resetPanel();
      return;
    }

    // Show panel, hide quick links
    if (searchPanel) searchPanel.classList.add('visible');
    if (quickLinks) quickLinks.style.display = 'none';

    // Keyword match against the index
    var words = query.split(/\s+/).filter(function(w) { return w.length > 0; });
    var matches = [];

    for (var i = 0; i < faqIndex.length; i++) {
      var f = faqIndex[i];
      var allMatch = true;
      for (var w = 0; w < words.length; w++) {
        if (f.qText.indexOf(words[w]) === -1 && f.aText.indexOf(words[w]) === -1) {
          allMatch = false;
          break;
        }
      }
      if (allMatch) matches.push(f);
    }

    // Render keyword hits into the panel
    renderHits(matches, words);

    // Reset AI state
    if (aiSkeleton) aiSkeleton.classList.remove('visible');
    if (aiResultEl) { aiResultEl.classList.remove('visible'); aiResultEl.innerHTML = ''; }
    if (noResults) noResults.classList.remove('visible');
    if (abortCtrl) { abortCtrl.abort(); abortCtrl = null; }

    countEl.textContent = matches.length + ' result' + (matches.length !== 1 ? 's' : '') + ' found';
    countEl.classList.add('visible');

    // If zero keyword matches and query is long enough → ask Haiku
    if (matches.length === 0 && query.length >= 3 && apiUrl) {
      fetchAiAnswer(query, 0);
    } else if (matches.length === 0) {
      if (noResults) noResults.classList.add('visible');
    }
  }

  // ============ QUICK LINKS ============
  document.querySelectorAll('.kl-hc-quick-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var label = this.textContent.trim();
      // "Track Order" / "Track my order" quick link opens the tracking drawer
      if (/track\s*(my\s*)?order/i.test(label)) {
        if (window.klDrawers) window.klDrawers.openTrack();
        return;
      }
      // "Cancel Subscription" or similar opens the subscription drawer
      if (/cancel\s*subscription|manage\s*subscription/i.test(label)) {
        if (window.klDrawers) window.klDrawers.openSub();
        return;
      }
      searchInput.value = label;
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus();
      // Scroll to search if needed
      var hdrH = getHeaderHeight();
      var top = searchInput.getBoundingClientRect().top + window.pageYOffset - hdrH - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // ============ KEYBOARD SHORTCUTS ============
  document.addEventListener('keydown', function(e) {
    if (e.key === '/' && !e.ctrlKey && !e.metaKey && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
      e.preventDefault();
      if (searchInput) searchInput.focus();
    }
    if (e.key === 'Escape' && document.activeElement === searchInput) {
      if (searchInput.value) {
        searchInput.value = '';
        searchWrap.classList.remove('has-value');
        doSearch();
      } else {
        searchInput.blur();
      }
    }
  });

  // ============ DEEP LINK ON LOAD ============
  function handleHash() {
    var hash = window.location.hash.slice(1);
    if (!hash || !hash.startsWith('faq-')) return;
    var target = document.getElementById(hash);
    if (!target) return;

    // Expand the parent subcategory
    var subcat = target.closest('[data-hc-subcat]');
    if (subcat && !subcat.classList.contains('open')) {
      subcat.classList.add('open');
      var subcatBody = subcat.querySelector('.kl-hc-subcat-body');
      if (subcatBody) { subcatBody.style.maxHeight = 'none'; }
      subcat.querySelector('.kl-hc-subcat-q').setAttribute('aria-expanded', 'true');
    }

    // Open the FAQ
    target.classList.add('open');
    var faqBody = target.querySelector('.kl-hc-faq-a');
    if (faqBody) { faqBody.style.maxHeight = 'none'; }
    var qBtn = target.querySelector('.kl-hc-faq-q');
    if (qBtn) qBtn.setAttribute('aria-expanded', 'true');

    // Highlight briefly
    target.classList.add('kl-hc-highlighted');
    setTimeout(function() { target.classList.remove('kl-hc-highlighted'); }, 3000);

    setTimeout(function() {
      var hdrH = getHeaderHeight();
      var top = target.getBoundingClientRect().top + window.pageYOffset - hdrH - 24;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }, 150);
  }

  handleHash();
  window.addEventListener('hashchange', handleHash);

  // ============ HELPERS ============
  function getHeaderHeight() {
    var header = document.querySelector('header, .header, #shopify-section-header');
    return header ? header.offsetHeight : 0;
  }

  // Drawer code moved to kl-drawers.js — access via window.klDrawers

  // ============ SHOPIFY THEME EDITOR ============
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.kl-hc-hero')) {
      // Expand all subcategories in editor for visibility
      document.querySelectorAll('.kl-hc-subcat').forEach(function(sc) {
        sc.classList.add('open');
      });
    }
  });

})();
